import { defineNuxtPlugin } from "nuxt/app";
import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
export default defineNuxtPlugin(async () => {
  countries.registerLocale(en);
});